import { render, staticRenderFns } from "./ConfiguracoesAplicativo.vue?vue&type=template&id=593e5370&scoped=true"
import script from "./ConfiguracoesAplicativo.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesAplicativo.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=593e5370&prod&scoped=true&lang=css&external"
import style1 from "./ConfiguracoesAplicativo.vue?vue&type=style&index=1&id=593e5370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593e5370",
  null
  
)

export default component.exports